module.exports = __webpack_public_path__ + "img/return_vs_risk.c281d7a8.png";